import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { SupportedLocale } from "@/i18n";
import { resolveLocale } from "@/i18n";

interface LocaleState {
  locale: SupportedLocale;
  setLocale: (locale: SupportedLocale) => void;
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: resolveLocale(navigator.language),
      setLocale: (locale) => set({ locale }),
    }),
    { name: "runcheetah-locale" },
  ),
);
